<template>
    <div
        v-if="!loading"
        class="flex flex-col min-h-screen"
    >
        <navigation
            v-if="navigation"
            :doc="navigation"
        />
        <!--site-header
            v-if="header"
            :doc="header"
        /-->

        <main class="pt-10 pb-20">
            <div class="container px-5 mx-auto max-w-6xl">
                <asset
                    v-if="doc.cover"
                    :url="doc.cover"
                    :w="1200"
                    :h="600"
                    fit="crop_focal"
                    class="mb-10"
                />

                <div class="text-center">
                    <div v-if="doc.subtitle">
                        <h5 class="strong uppercase tracking-widest font-thin">
                            {{ doc.subtitle}}
                        </h5>
                    </div>
                    <h1 class="uppercase font-medium">
                        {{ doc.title }}
                    </h1>
                </div>
            </div>
        </main>

        <site-footer
            v-if="footer"
            :doc="footer"
        />
    </div>
</template>

<script>
import site from "@/mixins/site";

export default {
    name: "page",

    mixins: [site],

    created() {
        console.log("Artikel");
        console.log(this);
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Article.vue